
const REQUEST_TYPE = {
    GET_STATE: 0,
    ROLL_DICE: 1,
    MAKE_MOVE: 2
};

const REQUEST_METOD_NAME = [
    'getGameState',
    'rollTheDice',
    'makeMove'
]



export class Network {
    constructor(game, gameId, playerId) {
        this._playerId = playerId;
        this._enemyId = 3//null;
        this._gameId = gameId;

        this._currentMoveNumber = 0;

        this.preUrlString = 'http://fastline.club/nardbet/ajax/';

        this.game = game;
    }

    setPlayerId(id) {
        this._playerId = id;
    }

    setEnemyId(id) {
        this._enemyId = id;
    }

    setGameId(id) {
        this._gameId = id;
    }

    pollingEnemyTurn() {
        //let opponentEndTurn = false;

        $.ajax({
            url: this.preUrlString + REQUEST_METOD_NAME[REQUEST_TYPE.GET_STATE],
            type: "POST",
            data: {
                gameId: this._gameId,
            },
            success: (data) => {
                console.log('POLL STATE: ', data);
                console.log('PLAYER ID: ', this._playerId, this._currentMoveNumber);

                if (!data.success) {
                    console.log('ERROR POLL: ', data.errors[0])
                }
                else {
                    if (data.data.currentPlayer != this._playerId ) {
                        setTimeout(() => {this.pollingEnemyTurn()}, 1000);
                    }
                    else {
                        this._currentMoveNumber = data.data.currentMoveNumber;
                        this.game.showEnemyTurn(data.data);
                    }
                }
            },
            error: (err) => {
                console.log('ERROR POLL', err)
            },
            dataType: 'json',
        });
    };

    getGameState(done) {
        $.ajax({
            url: this.preUrlString + REQUEST_METOD_NAME[REQUEST_TYPE.GET_STATE],
            type: "POST",
            data: {
                gameId: this._gameId,
            },
            success: (data) => {
                console.log('GAME STATE: ', data);

                if (!data.success) {
                    console.log('ERROR GET STATE: ', data.errors[0])
                }
                else {
                    this._currentMoveNumber = data.data.currentMoveNumber;
                    this.game.resolveGameState(data.data);//done();
                }
            },
            error: (err) => {
                console.log('ERROR GET STATE', err)
            },
            dataType: 'json',
        });
    };

    rollDice(done) {
        $.ajax({
            url: this.preUrlString + REQUEST_METOD_NAME[REQUEST_TYPE.ROLL_DICE],
            type: "POST",
            data: {
                gameId: this._gameId,
                currentPlayer: this._playerId
            },
            success: (res) => {
                console.log('ROLL DICE RESULT: ', res);

                if (!res.success) {
                    console.log('ERROR ROLL DICE: ', res.errors[0])
                }
                else {
                    this.game.startPlayerTurn(res.data, res.data.dice);//done();
                }
            },
            error: (err) => {
                console.log('ERROR ROLL DICE', err)
            },
            dataType: 'json',
        });
    };

    sendTurnMove(move, done) {

        console.log(move);

        $.ajax({
            url: this.preUrlString + REQUEST_METOD_NAME[REQUEST_TYPE.MAKE_MOVE],
            type: "POST",
            data: {
                gameId: this._gameId,
                currentPlayer: this._playerId,
                moveData: JSON.stringify(move),
            },
            success: (data) => {
                console.log('MAKE MOVE RESULT: ', data);

                if (!data.success) {
                    console.log('ERROR MAKE MOVE: ', data.errors[0])
                }
                else {
                    done();
                }
            },
            error: (err) => {
                console.log('ERROR MAKE MOVE', err)
            },
            dataType: 'json',
        });
    }

    // req() {
    //     $.ajax({
    //         url: 'http://fastline.club/nardbet/ajax/getGameState',
    //         type: "POST",
    //         data: {
    //             gameId:1,
    //             //currentPlayer:3
    //         },
    //         success: (data) => {
    //             console.log('SUCCESS', data);
    //         },
    //         error: (err) => {
    //             console.log('ERROR', err)
    //         },
    //         dataType: 'json',
    //         //timeout: 5000
    //     });
    // }


}


// WEBPACK FOOTER //
// ./src/network_api.es6